import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl } from '@angular/forms';
import { map, Observable, startWith, Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { Zones } from '../../../../../../commons/models/zone';
import * as ZonesActions from '../../../../../../store/actions/zones.actions';
import { Tenants } from '../../../../../../commons/models/tenants';

@Component({
  selector: 'app-new-zones',
  templateUrl: './new-zones.component.html',
  styleUrls: ['./new-zones.component.scss']
})
export class NewZonesComponent implements OnInit {
private unsubscribe$ = new Subject<void>();
  zonesForm: UntypedFormGroup;
  tenants: Tenants[] = [];
  filteredTenants: Observable<Tenants[]>;

  private _zone: Zones;

  constructor(
    private store$: Store<AppState>,
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this._createForm();
    if (this.data) {
      this.zone = this.data.zone;
      this.tenants = this.data.tenants || [];
    }
  }

  private _filterTenants(value: string | Tenants): Tenants[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return filterValue ? this.tenants.filter(tenant => tenant.name.toLowerCase().includes(filterValue)) : this.tenants;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    this.zonesForm = this.fb.group({
      name: ["", Validators.required],
      shipping_cost: ["", Validators.required],
      latitude: ["", [Validators.required, Validators.min(-90), Validators.max(90)]],
      longitude: ["", [Validators.required, Validators.min(-90), Validators.max(90)]],
      radius: ["", Validators.required],
      tenant_id: ["", Validators.required]
    });

    this.filteredTenants = this.zonesForm.get('tenant_id').valueChanges.pipe(
      startWith(''),
      map(value => this._filterTenants(value))
    );
  }

  private ngOnChanges() {
    if (this.zonesForm) {
      this.zonesForm.reset();
      if (this.zone) {
        this._initFormValues(this.zone);
      } else {
        this._initFormValues();
      }
    }
  }

  private _initFormValues(zone?: Zones) {
    if (zone) {
      this.zonesForm.patchValue({
        name: zone.name,
        shipping_cost: zone.shipping_cost,
        radius: zone.radius,
        latitude: zone.latitude,
        longitude: zone.longitude,
        tenant_id: zone.tenant_id
      });
    } else {
      this.zonesForm.markAllAsTouched();
    }
  }

  private _prepareSaveZones(): Zones {
    let savingZones: Zones = Zones.fromFormGroup(this.zonesForm, this.zone);
    return savingZones;
  }

  save() {
    let unsavedZones = this._prepareSaveZones();
    this.zonesForm.markAsDirty();
    this.store$.dispatch(ZonesActions.saveZone({ zones: unsavedZones }));
  }

  close() {
    if (this.zonesForm.dirty) {
        this.store$.dispatch(ZonesActions.requestCloseZonesDialog());
      } else {
        this.store$.dispatch(ZonesActions.closeZonesDialog());
      }
  }

  deleteZones() {
    if (this.zone) {
      this.store$.dispatch(ZonesActions.deleteZone({ zone: this.zone.toDTO() }));
    }
  }


  revert() {
    this.ngOnChanges();
  }

  get zone(): Zones {
    return this._zone;
  }

  set zone(zone: Zones) {
    this._zone = zone;
    this.ngOnChanges();
  }

  displayTenant = (id: number): string => {
    return this.tenants?.find(tenant => tenant.id === id)?.name || '';
  }
}
